export default {
  "content": "<path d=\"M7.5 5.624v6.875m5-5v6.875m.42 2.915l4.062-2.031a.937.937 0 00.518-.839V4.016a.938.938 0 00-1.357-.839L12.92 4.79a.938.938 0 01-.838 0L7.919 2.71a.937.937 0 00-.838 0l-4.063 2.03a.938.938 0 00-.518.84v10.403a.937.937 0 001.357.838l3.224-1.612a.938.938 0 01.838 0l4.162 2.081a.937.937 0 00.838 0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none"
  }
};